module.exports = __webpack_public_path__ + "img/door-contact-lg.3f40cb02.svg";